import {
  Controller,
  Get,
  Post,
  Body,
  Patch,
  Param,
  Delete,
  HttpCode,
  HttpStatus,
  Query,
} from '@nestjs/common';
import { StateService } from '../services/state.service';
import { CreateStateDto } from '../dto/create-state.dto';
import { UpdateStateDto } from '../dto/update-state.dto';

@Controller('states')
export class StateController {
  constructor(private readonly stateService: StateService) {}

  @Post()
  @HttpCode(HttpStatus.CREATED)
  create(@Body() createStateDto: CreateStateDto) {
    return this.stateService.create(createStateDto);
  }

  @Post('bulk')
  @HttpCode(HttpStatus.CREATED)
  bulkCreate(@Body() statesData: CreateStateDto[]) {
    return this.stateService.bulkCreate(statesData);
  }

  @Get()
  findAll() {
    return this.stateService.findAll();
  }

  @Get('country/:countryId')
  findByCountry(@Param('countryId') countryId: string) {
    return this.stateService.findByCountry(countryId);
  }

  @Get(':id')
  findOne(@Param('id') id: string) {
    return this.stateService.findOne(id);
  }

  @Patch(':id')
  update(@Param('id') id: string, @Body() updateStateDto: UpdateStateDto) {
    return this.stateService.update(id, updateStateDto);
  }

  @Delete(':id')
  @HttpCode(HttpStatus.NO_CONTENT)
  remove(@Param('id') id: string, @Query('soft') soft?: string) {
    if (soft === 'true') {
      return this.stateService.softDelete(id);
    }
    return this.stateService.remove(id);
  }
}